import jquery from "jquery";

const $ = jquery;

$(document).ajaxSuccess(() => {
    setShoppingListSticky();
});

window.addEventListener("load", () => {
    if (!window.mobileMedia) {
        setShoppingListSticky();
    }
});

function setShoppingListSticky() {
    const cartLeftSide = document.querySelector(".js-cart-wide");
    const cartRightSide = document.querySelector(".js-cart-narrow");

    if (cartRightSide && cartLeftSide) {
        if (!cartLeftSide.querySelector(".js-upsell-check-availability")) {
            const shoppingList = cartLeftSide.querySelector(".js-shopping-list");

            if (cartRightSide.offsetHeight > shoppingList.offsetHeight) {
                shoppingList.style.position = "sticky";
                shoppingList.style.top = "25px";
            } else {
                shoppingList.style.removeProperty("position");
                shoppingList.style.removeProperty("top");
            }
        }
    }
}
